import { FC } from "react";
import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent from "./order/order-optimizer-raily-details-hidden-details-center-tables-orders-order-table.component";
import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent from "./step-summary/order-optimizer-raily-details-hidden-details-center-tables-orders-step-summary.component";
import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent from "./order-summary/order-optimizer-raily-details-hidden-details-center-tables-orders-order-summary.component";
import {
  OrderOptimizerRailyDetailsItemDriver,
  OrderOptimizerRailyDetailsItemStepsOrdersPoints,
  OrderOptimizerRailyDetailsItemOrders,
  OrderOptimizerRailyDetailsItemStepsOrders,
} from "../../../common/types/order-optimizer-raily-details-item";

type OrderOptimizerRailyDetailsHiddenDetailsTablesOrdersProps = {
  driver: OrderOptimizerRailyDetailsItemDriver | null;
  allStepPoints: OrderOptimizerRailyDetailsItemStepsOrdersPoints[];
  order: OrderOptimizerRailyDetailsItemOrders;
  step: OrderOptimizerRailyDetailsItemStepsOrders;
  stepOffset: number;
  orderIndex: number;
};

const OrderOptimizerRailyDetailsHiddenDetailsTablesOrdersComponent: FC<
  OrderOptimizerRailyDetailsHiddenDetailsTablesOrdersProps
> = (props) => {
  return (
    <>
      <div className="order_optimizer_raily_details_hidden_details_center_tables_orders">
        <div className="order_optimizer_raily_details_hidden_details_center_tables_orders__left">
          <OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent
            order={props.order}
            orderIndex={props.orderIndex}
          />
        </div>
        <div className="order_optimizer_raily_details_hidden_details_center_tables_orders__right">
          <div className="order_optimizer_raily_details_hidden_details_center_tables_orders__right__order">
            <OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent
              driver={props.driver}
              allStepPoints={props.allStepPoints}
              stepPoints={props.step.points}
              stepOffset={props.stepOffset}
            />
          </div>
          <div className="order_optimizer_raily_details_hidden_details_center_tables_orders__right__summary">
            <OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent
              driver={props.driver}
              step={props.step}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderOptimizerRailyDetailsHiddenDetailsTablesOrdersComponent;
